/* Wishlist form stub — no-op unless wishlist UI is present */
(function () {
  'use strict';
  if (!document.querySelector('[data-wishlist], .wishlist, .halo-wishlist')) return;
})();
